<app-page-header title="Detalle de póliza {{policyNumber}}" subtitle="" [accent]="true"></app-page-header>

<div class="container">
    <div *ngIf="undefined === policy" class="products-detail-container pre-loading">
        <p>Cargando<span>.</span><span>.</span><span>.</span></p>
    </div> 

    <div class="no-text-select products-detail-container">

        <div *ngIf="undefined !== policy">

            <div class="products-detail-container-product">
                <app-product-item [data]=policy></app-product-item>
            </div>

            <app-collapse-container *ngIf="policy.coverage !== undefined" caption="Coberturas contratadas">
                <div class="coverage-table">
                    <div class="coverage-table-header">
                        <div class="coverage-col-desc">Coberturas</div>
                        <div class="coverage-col-capital" *ngIf="policy.productId !== 'DJ21'">Capital</div>
                        <div class="coverage-col-free" *ngIf="policy.productId !== 'DJ21'">Capital libre elección</div>
                    </div>
                    <div *ngFor="let item of policy.coverage">
                        <app-product-coverage [data]="item"></app-product-coverage>
                    </div>
                </div>
            </app-collapse-container>

            <app-collapse-container *ngIf="policy.insured !== undefined" caption="Datos del seguro">
                <app-product-data *ngFor="let insured of policy.insured; let i = index" [insured]="insured" [first]="i===0"></app-product-data>
            </app-collapse-container>

            <app-collapse-container *ngIf="(policy.building !== undefined) || (policy.vehicle !== undefined)" caption="Datos del objeto asegurado">

                <div *ngFor="let b of policy.building">
                    <app-product-insured-building [data]="b"></app-product-insured-building>
                </div>

                <div *ngFor="let v of policy.vehicle">
                    <app-product-insured-vehicle [data]="v"></app-product-insured-vehicle>
                </div>

            </app-collapse-container>

            <app-collapse-container *ngIf="((policy.occupier !== undefined) || (policy.guarantor !== undefined))" caption="Inquilino / Avalista">
                <app-product-tenant [occupier]="policy.occupier" [guarantor]="policy.guarantor"></app-product-tenant>
            </app-collapse-container>

            <app-collapse-container *ngIf="policy.receipt !== undefined" caption="Último recibo">
                <app-product-last-receipt [data]="policy.receipt" [policyNumber]="policy.number"></app-product-last-receipt>
            </app-collapse-container>

            <app-collapse-container *ngIf="policy.clause !== undefined" caption="Consultas">
                <div class="clause-table">
                    <div class="clause-table-header">
                        <div class="clause-col-name">Nombre</div>
                        <div class="clause-col-desc">Descripción</div>
                    </div>
                    <div *ngFor="let item of policy.clause">
                        <app-product-clause [data]="item"></app-product-clause>
                    </div>
                </div>
            </app-collapse-container>

        </div>

    </div>
</div>

<app-footer></app-footer>
